import { Token } from "../Contenedores/ClasesOAuth";

function guardarToken(token: Token) {
  localStorage.setItem("token", JSON.stringify(token));
}

export function obtenerToken() {
  const token = localStorage.getItem("token") || "";
  let parsedToken = token ? JSON.parse(token) : "";
  return parsedToken;
}

export function obtenerAccessToken() {
  let token = obtenerToken();
  return token.access_token;
}

function obtenerRefreshToken() {
  let token = obtenerToken();
  return token.refresh_token;
}

function eliminarToken() {
  localStorage.removeItem("token");
}

export default {
  guardarToken,
  obtenerToken,
  obtenerAccessToken,
  obtenerRefreshToken,
  eliminarToken,
};
